<template>
  <section>
    <b-modal
      id="assignPositionID"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      size="lg"
      :visible="openDeleteRecModal"
      @show="getDeleteRecruiterData"
      @hidden="closeModal"
    >
      <header class="d-flex align-items-center justify-content-between p-3">
        <div class="b-modal-header">Delete Recruiter</div>
        <div class="rotate-on-hover pointer">
          <img
            @click="closeModal"
            v-b-tooltip.hover.top="'Close'"
            src="@/assets/img/accessconnew/blueCross.svg"
            alt
          />
        </div>
      </header>
      <hr class="my-0" />
      <body class="set-padding">
        <div class="d-flex align-items-center">
          <div class="set-w-px">
            <img src="@/assets/new-kanban-icons/inform-icon.svg" alt="" />
          </div>
          <div class="ml-1">
            <div class="addTocandJob-head">
              Existing Position IDs tagged to
              <strong> “{{ recruiterName }}” </strong> has to be reallocated
            </div>
            <div class="addTocandJob-subhead">
              Position IDs without the candidates can be moved to unallocated
            </div>
          </div>
        </div>
        <b-skeleton-wrapper :loading="loaderStatus">
          <template #loading>
            <b-row v-for="(i, index) in 5" :key="index" class="mt-4 w-100">
              <b-col class="shimmer">
                <b-skeleton type="input"></b-skeleton>
              </b-col>
            </b-row>
          </template>
          <div class="mt-3" id="customised-table">
            <b-table
              responsive
              no-border-collapse
              hover
              :items="itemsData"
              :fields="fields"
              :sort-by="sortBy"
              :sort-desc="sortDesc"
              @sort-changed="onSortChanged"
            >
              <template #head()="{ label, field: { key, sortable } }">
                <div
                  class="d-flex align-items-center"
                  :class="key == 'positionID' ? 'ml-5' : ''"
                >
                  <div @click.stop="">
                    {{ label }}
                  </div>
                  <template v-if="sortable">
                    <img
                      class="ml-2"
                      v-if="sortBy === key && sortDesc"
                      src="@/assets/new-kanban-icons/sort-descending-icons.svg"
                      alt=""
                    />
                    <img
                      v-else-if="sortBy === key && !sortDesc"
                      class="ml-2"
                      src="@/assets/new-kanban-icons/sort-ascending-icons.svg"
                      alt=""
                    />
                    <img
                      class="ml-2"
                      v-else
                      src="@/assets/new-kanban-icons/empty-sort-icons.svg"
                      alt=""
                    />
                  </template>
                </div>
              </template>

              <template #cell()="data">
                <template
                  v-if="
                    data.field.key == 'positionID' ||
                    data.field.key == 'noOfCandidates'
                  "
                >
                  <div class="relativeclass">
                    <div
                      v-if="data.field.key == 'positionID'"
                      class="gridBlue-assign"
                    ></div>
                    <div
                      class="mt-1"
                      :class="data.field.key == 'positionID' ? 'ml-5' : ''"
                    >
                      <span
                        class="text-truncate d-inline-block"
                        style="min-width: auto; max-width: 85%"
                      >
                        {{ data.value }}</span
                      >
                    </div>
                  </div>
                </template>
                <template v-if="data.field.key == 'selectedRecruiterID'">
                  <div
                    ref="posdrop"
                    tabindex="0"
                    @focusout="hideDropdown"
                    class="relativeclass customised-table-dropdown"
                  >
                    <div
                      class="
                        d-flex
                        align-items-center
                        pointer
                        justify-content-center
                        h-100
                      "
                      :class="showSpinner && 'disabled-kanban-img'"
                      @click="
                        showSpinner
                          ? ''
                          : positionIDToggle == data.index
                          ? (positionIDToggle = null)
                          : (positionIDToggle = data.index)
                      "
                    >
                      <div class="w-80 d-flex justify-content-center">
                        <span
                          class="text-truncate d-inline-block"
                          style="min-width: auto; max-width: 85%"
                          >{{ getText(data.value) }}</span
                        >
                      </div>
                      <div class="w-20">
                        <img
                          v-if="positionIDToggle != data.index"
                          src="@/assets/new-kanban-icons/down-arrow.svg"
                          alt=""
                        />
                        <img
                          v-else
                          src="@/assets/new-kanban-icons/up-arrow.svg"
                          alt=""
                        />
                      </div>
                    </div>
                    <div
                      ref="posdrop"
                      v-if="positionIDToggle == data.index"
                      class="relativeclass"
                    >
                      <div
                        class="newInt-radio-dropdown p-0"
                        style="top: 5px; max-height: 130px; overflow-x: auto"
                      >
                        <b-form-group class="sec-mcq-datacard">
                          <b-form-radio-group
                            class="
                              newInt-radio-dropdown-inner-content
                              w-100
                              relativeclass
                            "
                            size="sm"
                            :options="getRecruiterOptions(data.index)"
                            buttons
                            stacked
                            v-model="data.value"
                            @change="setPosition(data)"
                          >
                          </b-form-radio-group>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                </template>
              </template>
            </b-table>
          </div>
        </b-skeleton-wrapper>
      </body>
      <hr class="my-0" />
      <footer
        class="
          d-flex
          align-items-center
          justify-content-between
          w-100
          bluebtn
          m-3
        "
      >
        <div>
          <b-button
            class="acs-cancelBtn-modal ml-2"
            :disabled="showSpinner"
            @click="!showSpinner && goBack()"
            >Back</b-button
          >
        </div>
        <div class="d-flex align-items-center mr-4">
          <b-button
            class="acs-cancelBtn-modal mr-3"
            :disabled="showSpinner"
            @click="!showSpinner && closeModal()"
            >Cancel</b-button
          >
          <div class="position-relative">
            <b-button
              class="acs-addBtn-modal pl-4 pr-4 mr-3"
              :class="
                showSpinner ? 'send-loader-class defaultCursor' : 'pointer'
              "
              :disabled="isSaveDisabled || showSpinner"
              @click="!showSpinner && deleteRecruiterManually()"
              >{{ showSpinner ? "" : "Save" }}</b-button
            >
            <div v-if="showSpinner" class="send-loader-pos">
              <Loader />
            </div>
          </div>
        </div>
      </footer>
    </b-modal>
  </section>
</template>

<script>
import Loader from "@/components/fixedcomponents/Loader.vue";
import { getDeleteRecruiterData, deleteRecruiter } from "@/utils/apiFunctions";

export default {
  name: "DeleteRecruiter",
  props: {
    openDeleteRecModal: Boolean,
    jobID: String,
    userID: String,
    recruiterName: String,
  },
  data() {
    return {
      items: {},
      itemsData: [],
      showSpinner: false,
      loaderStatus: false,
      positionIDToggle: null,
      sortDesc: null,
      sortBy: "",
      fields: [
        {
          key: "positionID",
          label: "Position ID",
          sortable: true,
        },
        {
          key: "noOfCandidates",
          label: "No of Candidates",
          sortable: true,
        },
        { key: "selectedRecruiterID", label: "Recruiter Name" },
      ],
    };
  },
  components: {
    Loader,
  },
  computed: {
    isSaveDisabled() {
      return this.itemsData.some((item) => item.selectedRecruiterID === "");
    },
  },
  methods: {
    async deleteRecruiterManually() {
      try {
        this.showSpinner = true;
        let positions = {};

        this.itemsData.forEach((item) => {
          if (!positions[item.selectedRecruiterID]) {
            positions[item.selectedRecruiterID] = [];
          }
          positions[item.selectedRecruiterID].push(item.positionID);
        });
        delete positions.unallocated;

        let payload = {
          jobID: this.jobID,
          user: this.userID,
          positions: positions,
        };
        let res = await deleteRecruiter(payload);
        if (res.status === 200) {
          this.showSpinner = false;
          this.$emit("delete-success");
        }
      } catch (error) {
        console.error(error);
      }
    },
    getRecruiterOptions(index) {
      if (this.itemsData[index].noOfCandidates === 0) {
        return this.recruiterOptions;
      } else {
        return this.items.recruiters.map((rec) => ({
          text: rec.username,
          value: rec.userID,
        }));
      }
    },
    getText(value) {
      return value == ""
        ? "Select"
        : this.recruiterOptions.find((rec) => rec.value === value).text;
    },
    hideDropdown(event) {
      if (
        this.$refs.posdrop &&
        !this.$refs.posdrop.contains(event.relatedTarget)
      ) {
        this.positionIDToggle = null;
      }
    },
    onSortChanged(field) {
      this.sortBy = field.sortBy;
      this.sortDesc = field.sortDesc;
    },
    setPosition(data) {
      this.itemsData[data.index].selectedRecruiterID = data.value;
      this.positionIDToggle = null;
      this.$forceUpdate();
    },
    async getDeleteRecruiterData() {
      try {
        this.loaderStatus = true;
        let payload = {
          user: this.userID,
          jobID: this.jobID,
        };
        let res = await getDeleteRecruiterData(payload);
        if (res.status === 200) {
          this.items = res.data.data;
          this.recruiterOptions = [
            { text: "Unallocated", value: "unallocated" },
            ...this.items.recruiters.map((rec) => ({
              text: rec.username,
              value: rec.userID,
            })),
          ];
          this.itemsData = this.items.positionInfo.map((pos) => ({
            positionID: pos.positionID,
            noOfCandidates: pos.noOfCandidates,
            selectedRecruiterID:
              pos.noOfCandidates === 0
                ? "unallocated"
                : this.recruiterOptions[1].value,
          }));
          this.loaderStatus = false;
        }
      } catch (error) {
        console.error(error);
      }
    },
    closeModal() {
      this.$emit("close-modal");
    },
    goBack() {
      this.$emit("go-back");
    },
  },
};
</script>

<style>
.addTocandJob-head {
  font-family: "Lato", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 25px;
  color: #333333;
}

.addTocandJob-subhead {
  font-family: "Montserrat", sans-serif;
  font-style: italic;
  font-weight: 500;
  font-size: 11px;
  line-height: 20px;
  color: #70737b;
}

.set-padding {
  padding: 15px 30px;
}

.set-w-px {
  width: 60px;
}

.gridBlue-assign {
  width: 4px;
  height: 46px;
  border-radius: 3px;
  position: absolute;
  left: -9px;
  top: -12px;
  background: #20639b;
}

.customised-table-dropdown {
  background: #eaeff3;
  border-radius: 25px;
  font-family: "Lato", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  width: 150px;
  height: 30px;
}

#assignPositionID .modal-body {
  padding: 0px;
}
</style>
